import React from 'react';
import './BlogActionCTA.css';

const BlogActionCTA = ({
  title = 'Make Smarter Decisions with Sonaroid Analytics',
  variant = 'light',
  showActions = true,
}) => {
  return (
    <section className={`blog-action-cta blog-action-cta--${variant}`}>
      <div className="page-container blog-action-cta-inner">
        <h2>{title}</h2>
        {showActions ? (
          <div className="blog-action-cta-actions">
            <a
              className="blog-action-cta-signup"
              href="https://app.sonaroid.io/signup"
              target="_blank"
              rel="noreferrer"
            >
              Sign Up
            </a>
            <a className="blog-action-cta-quote" href="/services">
              Get a Quote
            </a>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default BlogActionCTA;
